export default function (active = 'consultancy') {
    return {
        'development': 'dmenus',
        'consultancy': 'cmenus',
        'group': 'gmenus'
    }[active];
}